import React from 'react';
import PropTypes from 'prop-types';

import { Button } from 'components/ui/button';
import Modal from 'components/modal';

export default function DisableOperatingExpensesModal({ show, onCancel, onKeepLeaseTermValue }) {
  return (
    <Modal show={show} onHide={onCancel}>
      <Modal.Header closeButton>
        Disable Operating Expenses
      </Modal.Header>

      <Modal.Body>
        <p>
          This will delete all operating expenses and recalculate values.
        </p>
        <p>
          Would you like to:
          <ul>
            <li>Recalculate lease rate from the current total rent?</li>
            <li>Or, recalculate total rent from the current lease rate?</li>
          </ul>
        </p>
      </Modal.Body>

      <Modal.Footer>
        <Button label="Cancel" variant="ghost" onClick={onCancel} />
        <Button label="Recalculate lease rate" onClick={() => onKeepLeaseTermValue('leaseAmount')} />
        <Button label="Recalculate total rent" onClick={() => onKeepLeaseTermValue('leaseRate')} />
      </Modal.Footer>
    </Modal>
  );
}

DisableOperatingExpensesModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onKeepLeaseTermValue: PropTypes.func.isRequired,
};
